module.exports = class None {
  static get cssName() {
    return 'none';
  }

  render() {
    return '';
  }
};
